
import { useEffect } from "react";
import { motion } from "framer-motion";
import { Clock, AlertCircle, CheckCircle } from "lucide-react";

export default function ExpressDeliveryPage() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <main className="flex-grow pt-24 pb-24">
        <div className="container mx-auto px-4 py-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="max-w-4xl mx-auto"
          >
            <h1 className="text-4xl md:text-5xl font-bold font-playfair mb-8">
              24 Hour Priority Delivery - Terms & Conditions
            </h1>
            <div className="prose max-w-none space-y-6 text-gray-700">
              <div className="bg-yellow-50 border-l-4 border-yellow-400 p-6 rounded-lg my-8">
                <div className="flex items-start gap-4">
                  <AlertCircle className="w-6 h-6 text-yellow-600 flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-bold text-lg mb-2">Important Notice</h3>
                    <p>
                      Please read these terms carefully before selecting express delivery. The 24-hour
                      delivery service is subject to availability and specific conditions.
                    </p>
                  </div>
                </div>
              </div>
              <h2 className="text-3xl font-bold font-playfair mt-8 mb-4">Service Details</h2>
              <ul className="list-disc list-inside space-y-2">
                <li>24-hour delivery is available only in select areas of Delhi, NCR</li>
                <li>Orders must be placed before 2:00 PM for same-day processing</li>
                <li>Additional charges of ₹200 apply for express delivery</li>
                <li>Delivery is attempted between 9:00 AM and 9:00 PM</li>
              </ul>
              <h2 className="text-3xl font-bold font-playfair mt-8 mb-4">Eligibility</h2>
              <ul className="list-disc list-inside space-y-2">
                <li>Only prepaid orders are eligible for express delivery</li>
                <li>COD orders cannot use express delivery service</li>
                <li>Custom or personalized items may require additional time</li>
                <li>Service is subject to product availability</li>
              </ul>
              <h2 className="text-3xl font-bold font-playfair mt-8 mb-4">Delivery Attempts</h2>
              <p>
                We will make one delivery attempt. If the recipient is not available, the order will be
                rescheduled for standard delivery, and the express delivery charges will not be refunded.
              </p>
              <h2 className="text-3xl font-bold font-playfair mt-8 mb-4">Limitations</h2>
              <ul className="list-disc list-inside space-y-2">
                <li>Express delivery is not available on Sundays and public holidays</li>
                <li>Weather conditions or unforeseen circumstances may affect delivery time</li>
                <li>We are not liable for delays due to factors beyond our control</li>
              </ul>
              <h2 className="text-3xl font-bold font-playfair mt-8 mb-4">Refund Policy</h2>
              <p>
                If express delivery fails due to our error, the express delivery charges will be refunded.
                However, if the delay is due to incorrect address, recipient unavailability, or other
                customer-related issues, charges will not be refunded.
              </p>
            </div>
          </motion.div>
        </div>
      </main>
    </div>
  );
}
